var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.9375V12.375",
    stroke: "#F40909",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81313 3.43772L2.25063 16.5002C2.13015 16.7089 2.06662 16.9456 2.06641 17.1865C2.06619 17.4275 2.1293 17.6642 2.24941 17.8731C2.36952 18.082 2.54241 18.2557 2.75076 18.3767C2.95911 18.4977 3.19561 18.5619 3.43656 18.5627H18.5616C18.8025 18.5619 19.039 18.4977 19.2474 18.3767C19.4557 18.2557 19.6286 18.082 19.7487 17.8731C19.8688 17.6642 19.9319 17.4275 19.9317 17.1865C19.9315 16.9456 19.868 16.7089 19.7475 16.5002L12.185 3.43772C12.0654 3.22878 11.8928 3.05513 11.6845 2.93437C11.4763 2.8136 11.2398 2.75 10.9991 2.75C10.7583 2.75 10.5219 2.8136 10.3136 2.93437C10.1054 3.05513 9.9327 3.22878 9.81313 3.43772V3.43772Z",
    stroke: "#F40909",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.5C11.5695 16.5 12.0312 16.0383 12.0312 15.4688C12.0312 14.8992 11.5695 14.4375 11 14.4375C10.4305 14.4375 9.96875 14.8992 9.96875 15.4688C9.96875 16.0383 10.4305 16.5 11 16.5Z",
    fill: "#F40909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.3ad6bbff74d04bd878325368d188c29c.svg";
export { ForwardRef as ReactComponent };